import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';

import { Language } from 'src/app/master-data/master-data.model';
import {MatButton} from '@angular/material/button';

export interface LanguageSelectionDialogData {
  languages: Language[];
  selectedLocales: string[];
}

@Component({
  selector: 'app-language-selection-dialog',
  standalone: true,
  imports: [MatDialogModule, MatListModule, MatButton],
  templateUrl: './language-selection-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./language-selection-dialog.component.scss']
})
export class LanguageSelectionDialogComponent {
  readonly data = inject<LanguageSelectionDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<LanguageSelectionDialogComponent>);

  selected = new Set(this.data.selectedLocales);

  toggle(locale: string): void {
    if (this.selected.has(locale)) {
      this.selected.delete(locale);
    } else {
      this.selected.add(locale);
    }
  }

  save(): void {
    this.dialogRef.close([...this.selected]);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
